// complaint.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { complaint } = Dictionary

const complaintServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + complaint.list(),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + complaint.create(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + complaint.getById(id))
  },
  edit: async (id, data) => {
    return axios.put(baseURL + complaint.getById(id), data)
  },
  getDetailById: async (id,paramsObj) => {
    return axios.get(baseURL + complaint.getById(id),{params: paramsObj})
  },
   comment: async (id, data) => {
    return axios.put(baseURL + complaint.updateById(id), data)
  },
}
export default complaintServies